module.exports = __webpack_public_path__ + "static/media/6.6cd82c71.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/6.png
// module id = 686
// module chunks = 0